module.exports = __webpack_public_path__ + "static/media/backgroundLogin.92324e10.jpg";